/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

import zecQuestions from 'images/coin-pages/questions/zec.svg'

import { commonSlidesData } from '../commonPageData'

export const zecPage: ICoinPageData = {
  title: 'coin_1219',
  description: 'coin_1220',
  // description: 'coin_1221',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Zcash' }) }} />
  ),
  questionsBlock: {
    image: zecQuestions,
    questions: [
      {
        title: 'coin_1222',
        answer: 'coin_1223',
      },
      {
        title: 'coin_1224',
        answer: 'coin_1225',
      },
      {
        title: 'coin_1226',
        answer: 'coin_1227',
      },
      {
        title: 'coin_1228',
        answer: 'coin_1229',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Zcash (ZEC)'),
    text: [],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/borrow-like-a-pro/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_3200/https://coinrabbit.io/blog/wp-content/uploads/2022/06/Ltt.png',
        imageAlt: 'Crypto Loans: Tips and Tricks',
      },
      {
        link: 'https://coinrabbit.io/blog/whats-crypto-collateral-how-collateral-works/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/03/29486.png',
        imageAlt: 'What’s Crypto Collateral? How Collateral Works?',
      },
      {
        link: 'https://coinrabbit.io/blog/what-types-of-crypto-loans-are-there-and-how-can-i-profit-from-it/ ',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/12/1.png',
        imageAlt: 'What types of crypto loans are there and how can I profit from it?',
      },
    ],
    paragraphs: [
      {
        title: 'coin_1230',
        text: ['coin_1232'],
      },
      {
        title: 'coin_1231',
        text: ['coin_1233'],
      },
    ],
  },
}
